import Actions from './action';

export const initState = {
	isCompanyLoading: false,
	companyInfoData: [],
	savingCompanyInfoData: false,
	savingStatus: false,
};

const companyInfoReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.PUT_COMPANY_INFO_LOADING: {
			return {
				...state,
				isCompanyLoading: action.payload.loading,
			};
		}
		case Actions.types.SAVE_COMPANY_INFO_DATA_START: {
			return {
				...state,
				savingCompanyInfoData: true,
			};
		}
		case Actions.types.SAVE_COMPANY_INFO_DATA_SUCCESS: {
			return {
				...state,
				savingCompanyInfoData: false,
				savingStatus: true,
			};
		}
		case Actions.types.SAVE_COMPANY_INFO_DATA_ERROR: {
			return {
				...state,
				savingCompanyInfoData: false,
				savingStatus: false,
			};
		}
		case Actions.types.SAVE_COMPANY_INFO_DATA_RESET: {
			return {
				...state,
				savingCompanyInfoData: false,
				savingStatus: false,
			};
		}
		case Actions.types.GET_COMPANY_INFO_DATA_START: {
			return {
				...state,
				isCompanyLoading: true,
			};
		}
		case Actions.types.GET_COMPANY_INFO_DATA_SUCCESS: {
			return {
				...state,
				isCompanyLoading: false,
				companyInfoData: action.res.data,
			};
		}
		case Actions.types.GET_COMPANY_INFO_DATA_ERROR: {
			return {
				...state,
				isCompanyLoading: false,
			};
		}
		default:
			return state;
	}
};

export default companyInfoReducer;
